import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getOMIMGeneData } from "../../../../state/selectors/Omim.selectors";

import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import { formatModeofInheritance } from "../../../OMIM/helpers";

const GeneOMIMCard = ({ card, data }) => {
  const isDisabled = !Object.keys(data || {}).length;
  const [modesOfInheritance, setModesOfInheritance] = useState({});
  const [relatedDiseases, setRelatedDiseases] = useState(0);

  const countOccurrences = () => {
    if (data && data?.items) {
      const phenotypes = data.items
        .map((item) => {
          if (item?.phenotypes) {
            return item.phenotypes;
          }
          return null;
        })
        .flat()
        .filter(Boolean);
      if (phenotypes && phenotypes.length > 0) {
        const mode = phenotypes.map((e) => e.mode_of_inheritance);
        const flatClean = mode.flat().filter(Boolean);
        const occurrences = [...flatClean].reduce((acc, curr) => {
          // eslint-disable-next-line
          return (acc[curr] = (acc[curr] || 0) + 1), acc;
        }, {});
        setModesOfInheritance(occurrences);
      }
    }
  };

  const calcRelatedDiseases = () => {
    let count = 0;
    if (data && data?.items) {
      data.items.forEach((item) => {
        if (item?.phenotypes) {
          count += item.phenotypes.length;
        }
        return null;
      });
    }
    setRelatedDiseases(count);
  };

  const calcBackgroundColor = () => {
    let color = getPathogenicityColorByAllNames("P");
    if (relatedDiseases === 0) {
      color = getPathogenicityColorByAllNames("B");
    }
    return color;
  };

  useEffect(() => {
    countOccurrences();
    calcRelatedDiseases();
  }, [data]);
  return (
    <CardWrapper
      {...card}
      isDisabled={isDisabled}
      wizardId="omim"
      color={calcBackgroundColor()}
    >
      <>
        {relatedDiseases > 0 ? (
          <div data-testid="diseases">
            Related Diseases:{" "}
            <b data-testid="diseasesValue">{relatedDiseases}</b>
          </div>
        ) : null}
      </>
      <>
        {modesOfInheritance && Object.keys(modesOfInheritance).length > 0 && (
          <div data-testid="modesOfInheritance">
            {Object.entries(modesOfInheritance).map((item, i) => {
              return (
                <span key={i}>
                  {`${formatModeofInheritance(item[0])}: `}
                  <b>
                    <span data-testid={`${item[0]}_Value`}>{item[1]}</span>

                    {i === Object.entries(modesOfInheritance).length - 1
                      ? null
                      : ", "}
                  </b>
                </span>
              );
            })}
          </div>
        )}
      </>
    </CardWrapper>
  );
};

GeneOMIMCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  data: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        chromosome_sort: PropTypes.number,
        chromosome_symbol: PropTypes.string,
        computed_cyto_location: PropTypes.string,
        cyto_location: PropTypes.string,
        date_updated: PropTypes.string,
        omim_id: PropTypes.number,
        prefix: PropTypes.string,
        phenotypes: PropTypes.arrayOf(
          PropTypes.shape({
            phenotype_name: PropTypes.string,
            phenotype_mapping_key: PropTypes.number,
            omim_id: PropTypes.number,
            phenotypic_series: PropTypes.string,
            mode_of_inheritance: PropTypes.arrayOf(PropTypes.string),
          })
        ),
        references: PropTypes.arrayOf(
          PropTypes.shape({
            pub_med_references: PropTypes.arrayOf(PropTypes.number),
            reference_number: PropTypes.number,
            title: PropTypes.string,
            source: PropTypes.string,
            authors: PropTypes.string,
          })
        ),
        title: PropTypes.string,
        texts: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            content: PropTypes.string,
          })
        ),
        transcript: PropTypes.string,
        type: PropTypes.string,
      })
    ),
    version: PropTypes.string,
  }),
};

GeneOMIMCard.defaultProps = {
  data: {},
};

const mapStateToProps = (state) => ({
  data: getOMIMGeneData(state),
});

export default connect(mapStateToProps)(GeneOMIMCard);
